<section class="sidebar" #sidebarSection [ngClass]="{ opened: !sidebarService.isHidden() }">
  <app-sidebar
    [brandingData]="logoService.branding$ | async"
    [collapsed]="sidebarService.isCollapsed()"
  ></app-sidebar>
  <div class="toggle-icon clickable" (click)="sidebarService.toggle()">
    <app-icon-chevron
      [direction]="sidebarService.isCollapsed() ? 'right' : 'left'"
      [width]="20"
      [height]="20"
      [color]="'var(--color-gray-500)'"
    ></app-icon-chevron>
  </div>
</section>

<div
  class="backdrop"
  [ngClass]="{
    hidden: sidebarService.isHidden() && (sidebarPanelService.isPanelOpened$ | async) === false,
  }"
  (click)="hideOpenedPanel()"
></div>

<section class="content" #contentSection>
  <router-outlet></router-outlet>
</section>

@defer {
  @if (assistant.state.isDialogMode()) {
    <app-assistant-dialog [sidebarOffset]="sidebarOffset()"></app-assistant-dialog>
  }
}

@defer {
  @if (intercom.state.status()) {
    <app-intercom
      [sidebarOffset]="sidebarOffset()"
      [behindOverlays]="isSidebarOverlayOpen()"
      [fullWidth]="isPhoneLayout()"
    ></app-intercom>
  }
}
